import smCom from '../global/smCom.js';
import store from '@/store/index.js';

//同步读取文件二进制

//获得文件MD5


export const fSmUpLoadImg = {
  data() {
    return {
      ossParams: {
        success_action_status: '200', // 默认200
      }
    }
  },
  methods: {
    async fGetCompressImg(imgFile) {

      let presImg = await smCom.fSmCompressImg(imgFile, 0.7)
      console.log(presImg, '=========================>presImg')
      return presImg
    },
    async fUpLoadImg({
      mchId,
      type,
      proId,
      proName,
      imgFile,
      cloudType,
      imgMark
    }) {

      var p = new Promise(async (resolve, reject) => { //做一些异步操作
        let imgType = '';
        let imgUrl = '';
        if (imgFile.raw.type == 'image/jpeg') {
          imgType = '.jpg';
        } else if (imgFile.raw.type == 'image/png') {
          imgType = '.png';
        } else if (!imgFile.raw.type) {
          resolve(false)
        } else {
          this.$message('图片类型不正确');
          resolve(false)
        }
        console.log(imgFile)
        //压缩图片

        this.ossParams.key = 'p' + mchId + '/' + imgMark + '/' + proId + type + new Date()
          .getTime() + imgType;
        imgUrl = "https://u.91byk.com/" + this.ossParams.key
        let res
        console.log(this.$refs[type])
        res = await this.$refs[type].submit();
        resolve(imgUrl)

      });
      return p;
      console.log(imgFile)
    },
  },
}



// WEBPACK FOOTER //
// ./src/common/global/fSmUpLoadImg.js